// InvoiceViewItem Component

import { DragSource as dragSource, DropTarget as dropTarget } from 'react-dnd'
import ReactDom from 'react-dom'

import InvoiceViewItemBase from './invoice_view_itembase.jsx'

const phaseItemSource = {
  beginDrag (props, _monitor) {
    const item = props.item
    item.orgGroupId = item.groupId
    item.orgPhaseId = item.phaseId
    item.orgIndex = props.getItemIndex(item.dragId)

    if (props.onDragStart) {
      props.onDragStart(item)
    }

    return item
  },
  endDrag (props, monitor) {
    const item = monitor.getItem()
    const didDrop = monitor.didDrop()

    if (!didDrop && props.onMoveItem) {
      props.onMoveItem(
        item.phaseId,
        item.groupId,
        item.orgPhaseId,
        item.orgGroupId,
        null,
        item,
        item.orgIndex
      )
    }

    if (props.onDragEnd) {
      props.onDragEnd()
    }
  }
}

const phaseItemTarget = {
  hover (props, monitor, component) {
    const item = monitor.getItem()
    const overId = props.item.dragId

    const currentPos = props.getItemPosition(item.dragId)
    const overPos = props.getItemPosition(overId)

    const boundingRect = ReactDom.findDOMNode(
      component
    ).getBoundingClientRect()
    const clientOffset = monitor.getClientOffset()
    const ownMiddleY = boundingRect.bottom - boundingRect.top
    const offsetY = clientOffset.y - boundingRect.top

    if (currentPos < overPos && offsetY < ownMiddleY - 50) {
      return
    }

    if (currentPos > overPos && offsetY > 50) {
      return
    }

    if (props.onMoveItem && item.dragId !== overId) {
      props.onMoveItem(
        item.phaseId,
        item.groupId,
        props.item.phaseId,
        props.item.groupId,
        overId,
        item,
        null
      )
    }
  }
}

@dropTarget((_props) => 'all', phaseItemTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
}))
@dragSource((_props) => 'all', phaseItemSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
  dragItem: monitor.getItem()
}))
class InvoiceViewItem extends InvoiceViewItemBase {
  render () {
    const { connectDragPreview, connectDropTarget } = this.props
    return connectDragPreview(connectDropTarget(super.render()))
  }
}

export default InvoiceViewItem
